import { connect } from 'react-redux'
import { CategoryMenu as component } from './component'
import { setCategory } from '../hotelCategory/reducer'

const mapStateToProps = ({ activeCategory }) => {
  return {
    activeCategory
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onEnterHandler: () => {
      dispatch(setCategory('cat-ferien'))
    }
  }
}

const container = connect(
  mapStateToProps,
  mapDispatchToProps
)(component)

export { container as CategoryMenu }
export { component as SimpleCategoryMenu }
